















import { Component, Mixins } from "vue-property-decorator";
import { BarcodeItem } from "../../../../domain/document/items/BarcodeItem";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { ColorFixedObjectStyleReader } from "../styleReaders";
import {
  StyledDrawableObjectMixin
} from "./mixins";

@Component({
})
export default class BarcodeObject extends Mixins(
  StyledDrawableObjectMixin
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new ColorFixedObjectStyleReader(configuration.style.document.editor.objects.barcode);
  }

  editingSource: BarcodeItem;

  get label(): string {
    return (this.editingSource && this.editingSource.name)
      ? this.editingSource.name
      : "バーコード";
  }
}
